import React, { useState } from "react";
import _ from "lodash";

function useStepper({ initialSteps }) {
    const [steps, setSteps] = useState(initialSteps);
    const [active, setActive] = useState(0);
    const handleNext = () => {
        setActive((prevActiveStep) => prevActiveStep + 1);
    }

    const handleBack = () => {
        setActive((prevActiveStep) => prevActiveStep - 1);
    }

    const handleReset = () => {
        setActive(0);
    };

    const setStepError = (step, error) => {
        let newSteps = [...steps];
        newSteps[step].error = error;
        setSteps(newSteps);
    }

    const error = () => {
        return _.some(steps, (step) => (step.error));
    }

    const currentError = () => {
        return steps[active]?.error;
    }

    const onLast = () => {
        return (steps.length - 1) === active;
    }

    return { steps, setSteps, active, setActive, currentError, error, handleNext, handleBack, handleReset, setStepError, onLast };
}

export default useStepper;